import { useSelector } from 'react-redux';

import { IState } from 'models/reducers/i-state.interface';

import { parseThousandWithEmpty } from 'utils/parser.utils';

import VipPointIcon from 'assets/vip_point.png';

import NftCardBackCollapse from '../../../nftCardBackCollapse/NftCardBackCollapse';
import NftCardBackSlide from '../../../nftCardBackSlide/NftCardBackSlide';
import { useNftCardContext } from '../../../nftCardContext/NftCardContext';
import NftCardLabelPanel from '../../../nftCardLabelPanel/NftCardLabelPanel';
import NftCardShares from '../../../nftCardShares/NftCardShares';
import NftCardValue from '../../../nftCardValue/NftCardValue';

const NftCardBackStatisticsSlide = () => {
  const { asset } = useNftCardContext();
  const profile = useSelector(({ profile }: IState) => profile.profile);

  const panels = [
    {
      label: 'Royalties',
      children: (
        <>
          <NftCardLabelPanel label="Last 24h" primary>
            <NftCardValue {...asset?.royalties?.last24hours} />
          </NftCardLabelPanel>
          <NftCardLabelPanel label="Last 7d" primary>
            <NftCardValue {...asset?.royalties?.last7days} />
          </NftCardLabelPanel>
          <NftCardLabelPanel label="Total" primary>
            <NftCardValue {...asset?.royalties?.total} />
          </NftCardLabelPanel>
          {!!profile && (
            <NftCardLabelPanel label="Your Earnings" primary>
              <NftCardValue {...asset?.ownedEarnings} />
            </NftCardLabelPanel>
          )}
        </>
      ),
    },
    ...(asset?.burnVolume
      ? [
          {
            label: 'NFT Burn Volume',
            children: (
              <>
                <NftCardLabelPanel label="VIP points per share" primary>
                  <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-white">
                    <img src={VipPointIcon} alt="VIP points" className="tw-h-4 tw-w-4" aria-hidden />
                    {asset.burnVolume.vipPointsPerShare != null
                      ? parseThousandWithEmpty(asset.burnVolume.vipPointsPerShare)
                      : '-'}
                  </span>
                </NftCardLabelPanel>
                <NftCardLabelPanel label="Total burned" primary>
                  <NftCardShares>{parseThousandWithEmpty(asset.burnVolume.totalBurned)}</NftCardShares>
                </NftCardLabelPanel>
              </>
            ),
          },
        ]
      : []),
    {
      label: 'Sales volume',
      children: (
        <>
          <NftCardLabelPanel label="Last 7d">
            <NftCardValue {...asset?.salesVolume?.last7days} />
          </NftCardLabelPanel>
          <NftCardLabelPanel label="Last 30d">
            <NftCardValue {...asset?.salesVolume?.last30days} />
          </NftCardLabelPanel>
        </>
      ),
    },
  ];

  return (
    <NftCardBackSlide label="Statistics">
      {panels.map(({ label, children }) => (
        <NftCardBackCollapse key={label} label={label}>
          {children}
        </NftCardBackCollapse>
      ))}
    </NftCardBackSlide>
  );
};

export default NftCardBackStatisticsSlide;
